import { createSelector } from 'reselect';

import type ParcelTemplate from '~/types/ParcelTemplate';

import { type ApplicationState } from '../store';

const getPackagesStore = (state: ApplicationState) => state.packages;

export const getDefaultWeightUnit = createSelector(
  getPackagesStore,
  (packagesStore): string => packagesStore.defaultWeightUnit,
);

export const getDefaultDistanceUnit = createSelector(
  getPackagesStore,
  (packagesStore): string => packagesStore.defaultDistanceUnit,
);

export const getActiveParcelTemplate = createSelector(
  getPackagesStore,
  (packageStore): Maybe<ParcelTemplate> => packageStore.parcelTemplate,
);

export const getSavePackageTemplateModalIsOpen = createSelector(
  getPackagesStore,
  (packageStore): boolean => packageStore.savePackageTemplateModalIsOpen,
);
